import { siteSettingsDefaultFieldsToSelect } from "@contentful-api/constants/queryFields";
import { CMSWrapper } from "@lib/wrappers/cmsWrapper";

interface IGetSiteSettingsContentType {
    locale: string;
    localeTagId: string;
    otherFields?: string[];
    onlySelected?: boolean;
    textCollection?: string[];
}

export const getSiteSettingsContentType = async ({
    locale,
    localeTagId,
    otherFields,
    onlySelected,
    textCollection,
}: IGetSiteSettingsContentType) => {
    const fieldsToSelect = onlySelected
        ? otherFields
        : otherFields
          ? [...siteSettingsDefaultFieldsToSelect, ...otherFields]
          : siteSettingsDefaultFieldsToSelect;

    const siteSettings = await CMSWrapper.getInstance().getEntries({
        content_type: "siteSettings",
        locale,
        "metadata.tags.sys.id[in]": localeTagId,
        select: fieldsToSelect?.join(","),
        include: 10,
        limit: 1,
    });

    const entries = siteSettings?.includes?.Entry || [];

    return {
        siteSettings: siteSettings?.items?.[0] || null,
        ...Object.fromEntries(
            textCollection.map((text) => [
                text,
                entries.find((entry) => entry.fields.key === text) ?? null,
            ])
        ),
    };
};
